import { AgentProfile } from "@closerplatform/spinner-openapi";
import React from "react";
import { Avatar } from "@fidget/common/components/avatar/avatar";
import { DeleteCrossIcon } from "@fidget/common/components/icons/deleteCrossIcon/DeleteCrossIcon";
import styles from "./advisersList.css";

interface Props {
  advisers: AgentProfile[];
  onDelete?(adviser: AgentProfile): void;
}

export const AdvisersList = ({ advisers, onDelete }: Props) => {
  return (
    <div className={styles.container}>
      {advisers.map((adviser) => (
        <div key={adviser.id} className={styles["adviser-container"]}>
          <div className={styles.avatar}>
            <Avatar agent={adviser} />
          </div>
          <div className={styles["adviser-name"]}>{`${adviser.firstName} ${adviser.lastName}`}</div>
          {onDelete && <DeleteCrossIcon onClick={() => onDelete(adviser)} />}
        </div>
      ))}
    </div>
  );
};
